export const obfuscateString = async (text) => {
    const encodedContent = new TextEncoder().encode(text);
    const versionNumber = 0;
    const obfuscationHeader = convertArrayBufferToString(new Uint8Array([versionNumber, ...createRandomArrayBuffer(32)]));
    const key = await extractKey(obfuscationHeader);
    const iv = extractIV(obfuscationHeader);
    const obfuscatedContent = await crypto.subtle.encrypt({
        name: 'AES-GCM',
        iv: iv
    }, key, encodedContent);
    return `${obfuscationHeader}${convertArrayBufferToString(obfuscatedContent)}`;
};
export const deobfuscateString = async (value) => {
    const iv = extractIV(value);
    const key = await extractKey(value);
    const content = extractContentFromObfuscatedString(value);
    const arrayBufferContent = convertStringToArrayBuffer(content);
    const deobfuscatedContent = await crypto.subtle.decrypt({
        name: 'AES-GCM',
        iv: iv
    }, key, arrayBufferContent);
    return convertArrayBufferToString(deobfuscatedContent);
};
const extractContentFromObfuscatedString = (obfuscatedValue) => {
    return obfuscatedValue.substring(33);
};
const extractIV = (value) => {
    const ivString = value.substring(18, 29);
    return convertStringToArrayBuffer(ivString);
};
const extractKey = async (value) => {
    const keyString = value.substring(1, 17);
    const keyArrayBuffer = convertStringToArrayBuffer(keyString);
    return crypto.subtle.importKey('raw', keyArrayBuffer, { name: 'AES-GCM', length: 128 }, false, [
        'encrypt',
        'decrypt'
    ]);
};
const convertArrayBufferToString = (buffer) => {
    return String.fromCharCode.apply(null, [...new Uint8Array(buffer)]);
};
const convertStringToArrayBuffer = (value) => {
    const buffer = new ArrayBuffer(value.length);
    const bufferView = new Uint8Array(buffer);
    for (let i = 0, strLen = value.length; i < strLen; i++) {
        bufferView[i] = value.charCodeAt(i);
    }
    return buffer;
};
const createRandomArrayBuffer = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
//# sourceMappingURL=obfuscation-utils.js.map